import { render } from "./TipoFeriadoSelect.vue?vue&type=template&id=0b8ec54e"
import script from "./TipoFeriadoSelect.vue?vue&type=script&lang=js"
export * from "./TipoFeriadoSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__